import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import Excel from "../../assets/excel.png";
import control from "../../assets/control.png";
import señor from "../../assets/señor.jpg";
import gear from "../../assets/gear.png";

const Section2 = ({ imageSrc }) => {
    const navigate = useNavigate();

    return (
        <div className="bg-[#e8f2f4] py-16">
            <div className="text-[#033d8e] font-bold text-4xl text-center w-full mb-10" style={{ textShadow: '0px 2px 5px rgba(0,0,0,0.3)' }}>
                Ventajas de compartir tus datos con nosotros
            </div>

            <div className="flex justify-center gap-12">
       
                <div style={{ boxShadow: '-4px 20px 10px rgba(0,0,0,0.3)' }} className="bg-[#e8f2f4] p-6 rounded-3xl text-center w-1/3 flex flex-col items-center">
                    <h2 className="text-2xl font-bold text-[#034094] w-[65%] mx-auto text-center">
                        No necesitas llevar un registro manual de tus gastos en Excel
                    </h2>
                    <div className="flex justify-center my-4">
                        <img src={Excel} alt="Ícono de Excel" className="w-20 h-20" />
                    </div>
                    <p className="text-[#0346a4] font-bold w-[70%] mx-auto">
                        Accede a un resumen automático y categorizado de los gastos de todas tus cuentas bancarias en nuestra app.
                    </p>
                </div>


                <div style={{ boxShadow: '-4px 20px 10px rgba(0,0,0,0.3)' }} className="bg-[#0054c9] p-6 rounded-3xl text-center w-1/3">
                    <h2 className="text-2xl font-bold text-[#e8f2f4] w-[65%] mx-auto text-center">Toma el control de tu información</h2>
                    <div className="flex justify-center my-4">
                        <img src={control} alt="Ícono de Excel" className="w-20 h-20" />
                    </div>
                    <p className="text-[#ccddf6] font-bold w-[70%] mx-auto">
                        Decide con claridad quién puede acceder a tus datos y gestiona su uso de manera transparente.
                    </p>
                </div>


            </div>
            <div className="mt-12 mx-auto max-w-[70%] flex justify-center " >
                <Button shadowBox="shadow-[0px_4px_10px_rgba(0,0,0,0.5)]" onClick={() => navigate("/politica-datos")} text="Conoce nuestra Política de Tratamiento de Datos Personales" fullWidth="true" color="bg-[#032c65]" textColor="text-white" paddingY="py-5" paddingX="px-6" rounded="rounded-full" border="border-transparent" textSize="font-bold" disableHover={false} />
            </div>


            <div className="bg-[#e8f2f4] flex justify-center items-center gap-10 py-20">
 
                <div className="bg-[#e8f2f4] p-6 rounded-3xl text-center w-1/3">
                    <h2 className="text-4xl font-bold text-[#2f6fe8] text-left mb-4" style={{ textShadow: '0px 2px 5px rgba(0,0,0,0.3)' }}>
                        ¿Cómo funciona?
                    </h2>
                    <div className="flex flex-col items-start gap-4 text-xl">
                        <div className="flex items-center gap-2 text-[#0054c9] font-bold">
                            <img src={gear} alt="Engranaje" className="w-6 h-6" />
                            <p>Tu autorización te da el control</p>
                        </div>
                        <div className="flex items-start gap-2 text-[#0054c9] font-bold">
                            <img src={gear} alt="Engranaje" className="w-6 h-6" />
                            <p className="text-left">Tu información te pertenece, y tú eliges con quién compartirla.</p>
                        </div>
                    </div>
                    <div className="mt-6">
                        <Button text="Comienza" fullWidth={true} color="bg-[#36a31a]" textColor="text-white" rounded="rounded-full" />
                    </div>
                </div>



                <div className="w-1/3 flex justify-center">
                    <img src={señor} alt="Imagen de persona" className="w-full h-auto rounded-3xl" />
                </div>
            </div>




        </div>


    );
};

export default Section2;
